import { useState } from 'react';
import { readJson, writeJson } from '../lib/storage';

const KEY = 'tpubg:a2hs-hint';

/** iPhone/iPad Safari can't go truly fullscreen in the browser, but can from a home-screen icon. */
function shouldShow(): boolean {
  if (typeof window === 'undefined') return false;
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return ios && !standalone && !readJson<boolean>(KEY, false);
}

/** One-time tip for iPhone players: add the site to the home screen for fullscreen games. */
export function HomeScreenHint() {
  const [show, setShow] = useState(shouldShow);
  if (!show) return null;
  const close = () => {
    writeJson(KEY, true);
    setShow(false);
  };
  return (
    <div className="a2hs" role="note">
      <span className="a2hs__icon" aria-hidden="true">
        📲
      </span>
      <p className="a2hs__text">
        <strong>Play fullscreen on iPhone:</strong> tap{' '}
        <span className="a2hs__share" aria-label="Share">
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path d="M12 3v12M7 8l5-5 5 5M5 12v8h14v-8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>{' '}
        then <strong>Add to Home Screen</strong>.
      </p>
      <button type="button" className="a2hs__close" onClick={close} aria-label="Dismiss tip">
        ×
      </button>
    </div>
  );
}
